import { Box, keyframes, Typography } from '@mui/material';
import type { StepType } from '@reactour/tour';

const blinker = keyframes`
  50% {
    opacity: 0;
  }
`;

/**
 * This is a react tour for patient profile page autosave feature
 */
export const patientProfileAutoSave: StepType[] = [
  {
    selector: "[data-testid='save-changes-button']",
    content: () => (
      <>
        <Box
          sx={{
            position: 'fixed',
            top: '-60px',
            left: '16px',
            animation: `${blinker} 1s linear infinite`,
          }}
        >
          <img src="/images/save_button.png" />
        </Box>
        <Typography variant="h5">
          We&apos;ve introduced autosave, so you won&apos;t need to manually click <strong>save</strong> anymore!
        </Typography>
      </>
    ),
  },
  {
    selector: "[data-testid='patient-identification-info']",
    content: () => (
      <>
        <Typography variant="h5" marginBottom={5}>
          When everything is working, you&apos;ll see real-time feedback telling you that the info has been saved, and
          when it was last updated.
        </Typography>
        <video width="100%" height="100%" autoPlay loop preload="auto" src="/videos/medicare-demo.mp4" />
      </>
    ),
  },
  {
    selector: "[data-testid='ihi-information-section']",
    content: () => (
      <>
        <Typography variant="h5" marginBottom={5}>
          But, if there&apos;s a problem with the system, you&apos;ll see a message in real-time in the section
          you&apos;re editing, letting your know something hasn&apos;t saved properly.
        </Typography>
        <video width="100%" height="100%" autoPlay loop preload="auto" src="/videos/ihi-demo.mp4" />
      </>
    ),
  },
];

// tour for the collapsible menu feature
export const collapsibleMenu: StepType[] = [
  {
    selector: ".ButtonAppBar-menuToggle > button > [data-testid='MenuOpenIcon']",
    content: () => (
      <Typography variant="h5">
        Use this icon to <strong>expand</strong> and <strong>collapse</strong> the main navigation menu.
      </Typography>
    ),
    position: [40, 90],
    stepInteraction: true,
  },
];
